<template>
  <div class="fs-14 q-pr-8">
    <div class="white-space-normal">
      {{ organizationName }}
      <div>
        {{ organizationAddress }}
      </div>
      <div v-if="brand.is.localsride">
        Reg. number {{ brand.organization.regNumber }}
      </div>

      <template v-if="brand.is.gettransfer">
        <div class="q-mt-8 white-space-normal">
          {{ kgConnect.name[locale] || kgConnect.name.en }}
          <div>
            {{ kgConnect.address[locale] || kgConnect.address.en }}
          </div>
        </div>
        <div class="q-mt-8 white-space-normal">
          {{ gettransferMena.name[locale] || gettransferMena.name.en }}
          <div>
            {{ gettransferMena.address[locale] || gettransferMena.address.en }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import organizations from '~common/utils/organizations';

const { kgConnect, gettransferMena } = organizations;
const { locale } = useI18n();

const { brand } = inject('domain');

const organizationName = computed(() => {
  const name = brand.organization.name;
  if (typeof name === 'string') return name;
  return name[locale.value] || name.en || name.ru;
});

const organizationAddress = computed(() => {
  const address = brand.organization.address;
  return address[locale.value] || address.en || address.ru;
});
</script>
